import moment from "moment";

/**
 * Naručioci (jela iz grupa): radnici jedne firme i jedne smene sa obrocima po grupama jela i napomenom. Zahteva
 * nasleđen stari tab ReportTabGroupMealsTabCustomers2 (companyDailyOrders, mealCategories, selectedCompany, filters).
 * Bez firme ili za period duži od dana nema redova (stari tab bez firme baca grešku).
 */
export default {
  computed: {
    isRange() {
      const { from, to } = this.filters.dates;
      return Boolean(to && from !== to);
    },
    rows() {
      if (!this.selectedCompany || this.isRange) {
        return [];
      }
      const rows = this.companyDailyOrders.map((user) => {
        const cells = {};
        this.mealCategories.forEach((category) => {
          cells[category] = (Array.isArray(user[category]) ? user[category] : []).map((meal) => ({
            quantity: meal.quantity,
            name: this.toLatin(meal.name),
          }));
        });
        const fullname = this.toLatin(user.fullname);
        return {
          key: user.userId,
          userId: user.userId,
          id: user.id,
          fullname,
          dateText: user.date ? moment(user.date).format("DD.MM.YYYY") : "",
          note: user.note,
          cells,
          searchText: [fullname, user.note, ...Object.values(cells).flatMap((meals) => meals.map((meal) => meal.name))].join(" "),
        };
      });
      const search = this.filters.search;
      const found = search ? this.customSearch(rows, [{ value: "searchText" }], search) : rows;
      return [...found].sort((a, b) => a.fullname.localeCompare(b.fullname));
    },
    categoryTotals() {
      const totals = {};
      this.mealCategories.forEach((category) => {
        totals[category] = this.rows.reduce(
          (sum, row) => sum + row.cells[category].reduce((inner, meal) => inner + (meal.quantity || 0), 0),
          0
        );
      });
      return totals;
    },
    mealTotal() {
      return this.mealCategories.reduce((sum, category) => sum + this.categoryTotals[category], 0);
    },
  },
};
